export const INVENTORY_DATA = {
    DELETE_INVENTORY_BTN: "delete-inventory-btn",
    ATS_REPORT_BTN: "ats-report-btn",
    DOWNLOAD_BTN: "inventory-download-btn",
    DIALOG: {
        INPUT_FIELD: "input-field",
    },
};
